import { render, staticRenderFns } from "./search-customer-dialog.vue?vue&type=template&id=398fb604&scoped=true&"
import script from "./search-customer-dialog.vue?vue&type=script&lang=js&"
export * from "./search-customer-dialog.vue?vue&type=script&lang=js&"
import style0 from "./search-customer-dialog.vue?vue&type=style&index=0&id=398fb604&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398fb604",
  null
  
)

export default component.exports